import React, { useContext, useState, useEffect, useMemo } from "react";
import "ol/ol.css"; //스타일
import { Feature, Map as OlMap, Overlay, View } from "ol";
import { get as getProjection } from "ol/proj"; //위경도
import { defaults as defaultControls } from "ol/control";
import { Vector, XYZ } from "ol/source";
import DataContext from "../../src/ContextServer/DataContext";

import VectorLayer from "ol/layer/Vector";
import { Point } from "ol/geom";
import LayerSwitcher from "ol-layerswitcher";
import "ol-layerswitcher/dist/ol-layerswitcher.css";
import LayerGroup from "ol/layer/Group";

import { Tile } from "ol/layer";
import { Style, Icon, Text, Fill, Stroke, Circle } from "ol/style";
import pinsvg from "./pin.svg";

const midNightMap = new Tile({
  //배경지도 레이어
  title: "다크지도",
  displayInLayerSwitcher: false,
  visible: true,
  source: new XYZ({
    url: "http://api.vworld.kr/req/wmts/1.0.0/681740AD-AFA7-4D08-9221-A506E4AF246F/midnight/{z}/{y}/{x}.png",
  }),
});

const baseMap = new Tile({
  //배경지도 레이어
  title: "배경지도",
  displayInLayerSwitcher: false,
  visible: false,
  source: new XYZ({
    url: "http://api.vworld.kr/req/wmts/1.0.0/681740AD-AFA7-4D08-9221-A506E4AF246F/Base/{z}/{y}/{x}.png",
  }),
});

const aerialMap = new Tile({
  //배경지도 레이어
  title: "항공사진",
  visible: false,
  source: new XYZ({
    url: "http://api.vworld.kr/req/wmts/1.0.0/681740AD-AFA7-4D08-9221-A506E4AF246F/Satellite/{z}/{y}/{x}.jpeg",
  }),
});

const hybridMap = new Tile({
  //배경지도 레이어
  title: "하이브리드",
  visible: true,
  source: new XYZ({
    url: "http://api.vworld.kr/req/wmts/1.0.0/681740AD-AFA7-4D08-9221-A506E4AF246F/Hybrid/{z}/{y}/{x}.png",
  }),
});

const aerialGroupMap = new LayerGroup({
  // 항공지도 그룹맵
  title: "항공지도",
  baseLayer: true,
  openInLayerSwitcher: true,
  visible: false,
  layers: [aerialMap, hybridMap],
});

const darkGroupMap = new LayerGroup({
  // 배경지도 그룹맵
  title: "배경지도(다크)",
  baseLayer: true,
  openInLayerSwitcher: true,
  visible: false,
  layers: [midNightMap, hybridMap],
});

const popupElement = document.createElement("div");
popupElement.style.display = "none";
popupElement.id = "popup";
document.body.appendChild(popupElement);

function NowDataMap(props) {
  const [mapObject, setMapObject] = useState(null);

  const poiLayer = useMemo(() => {
    const markerStyle = new Style({
      fill: new Fill({
        color: "rgba(255, 255, 255, 0.2)",
      }),
      stroke: new Stroke({
        color: "#3B11B2",
        width: 2,
      }),
      image: new Circle({
        radius: 12,
        fill: new Fill({
          color: "rgba(255, 255, 255, 0.4)",
        }),
        stroke: new Stroke({ color: "#3B11B2", width: 2 }),
      }),
    });
    let vectorLayer = new VectorLayer({
      source: new Vector({ wrapX: false }),
      style: markerStyle,
    });
    return vectorLayer;
  }, []);
  const markerLayer = useMemo(() => {
    let markerStyle = new Style({
      image: new Icon({
        //마커 이미지
        opacity: 1, //투명도 1=100%
        scale: 0.1, //크기 1=100%
        src: pinsvg,
      }),
      //html의 css, z-index 기능이다.
      zindex: 10,
    });

    let markerSource = new Vector();
    let markerLayer = new VectorLayer({
      source: markerSource, //마커 feacture들
      style: markerStyle, //마커 스타일
    });
    return markerLayer;
  }, []);

  useEffect(() => {
    if (mapObject === null) {
      // 지도 중복 생성 막음
      const map = new OlMap({
        // controls: defaultControls({ zoom: false, rotate: false }).extend([]),
        target: "mapc",
        view: new View({
          projection: getProjection("EPSG:3857"),
          zoom: 13,
          center: [14106451, 4162330],
        }),
      });
      map.addLayer(darkGroupMap);
      map.addLayer(baseMap);
      map.addLayer(aerialGroupMap);
      map.addLayer(poiLayer);
      map.addLayer(markerLayer);
      map.addControl(
        new LayerSwitcher({
          tipLabel: "레이어범례",
          mouseover: true,
          collapsed: true,
        }),
      );

      setMapObject({ map });

      map.on("singleclick", (evt) => {
        // console.log(evt.coordinate); // 클릭한 지점의 좌표
        markerLayer.getSource().clear();
        props.func(evt.coordinate);

        let markerFeature = new Feature({
          geometry: new Point(evt.coordinate),
        });

        markerLayer.getSource().addFeature(markerFeature);
      });
      return () => {
        map.setTarget(null);
      };
    }
  }, []);

  // getLastData(); // 데이터 조회 및 조회 결과에 따른 좌표 표현
  return (
    <div>
      <div className="nowDataMap">
        <div id="mapc" value={mapObject} style={{ height: "300px" }}></div>
      </div>
    </div>
  );
}
export default NowDataMap;
